import r from "./ghl-ui.es1394.js";
import m from "./ghl-ui.es1395.js";
import h from "./ghl-ui.es1396.js";
import l from "./ghl-ui.es1397.js";
import c from "./ghl-ui.es1398.js";
function e(t) {
  var o = -1, a = t == null ? 0 : t.length;
  for (this.clear(); ++o < a; ) {
    var p = t[o];
    this.set(p[0], p[1]);
  }
}
e.prototype.clear = r;
e.prototype.delete = m;
e.prototype.get = h;
e.prototype.has = l;
e.prototype.set = c;
export {
  e as default
};
